import { StatementActorEnum } from '../types/payment';

export const mapUserIdToStatementActor: Record<number, StatementActorEnum> = {
  '-1': StatementActorEnum.SATELLIE,
  '-2': StatementActorEnum.ANB_FEE,
  '-3': StatementActorEnum.ALPACA,
  '-4': StatementActorEnum.JADWA,
  '-6': StatementActorEnum.ALBILAD,
  // madkhol-payment `StatementStaticActorId.SNB`.
  '-8': StatementActorEnum.SNB,
};
